export default {
  getPointOfSalesIcon(element) {
    if (element.capacity_code > 0 || element.enrollment_capacity.toString() === '3') {
      return 'additional_capabilities'
    }
    if (element.enrollment_capacity.toString() === '1') {
      return 'enrollable'
    }

    return 'non_enrollable'
  }
}
